module.exports = __webpack_public_path__ + "img/elo.b19f6b9f.png";